/**
 * Snapflix S3 MP4 library (snapflix-mp4 bucket, Anime_mp4 prefix).
 * Filenames must match object keys in S3; URLs are built with encodeURIComponent.
 */
const BASE = 'https://snapflix-mp4.s3.ap-southeast-2.amazonaws.com/Anime_mp4/';

const FILE_NAMES = [
  '1 - Anime Edit.mp4',
  '10 - The King Thomas Andre.mp4',
  '100 - The Greatest Swordsman.mp4',
  '101 - 3 Swordsman.mp4',
  '102 - The Power Of Garp.mp4',
  '103 - The Marineford Arc.mp4',
  '104 - The Life Luffy Saved .mp4',
  '105 - The Power Of Gogeta.mp4',
  '106 - The Power Of Imu.mp4',
  '107 - The Power Fo Gol D Roger.mp4',
  '108 - The Promise Of Zoro.mp4',
  '109 - The Power Fo Sanji.mp4',
  '11 - Sung Jin Woo Aura.mp4',
  '110 - The Tale Of Naruto Uzumaki.mp4',
  '111 - Wise Words From Orochimaru.mp4',
  '112 - The Top 5 Anime Edit.mp4',
  '113 - Top 5 Anime.mp4',
  '114 - Attack On Titan.mp4',
  '115 - The Gol D Roger Treasure.mp4',
  '116 - Commander Erin Aura.mp4',
  '116 - The Onepiece Edit.mp4',
  '117 - Somebody Watching Me Edit.mp4',
  '118 - Eren Aura.mp4',
  '119 - Hakyuu Edit.mp4',
  '12 - Blue Lock Aura.mp4',
  '120 - Fire Force Edit.mp4',
  '121 - Jujutsu Kaise Edit.mp4',
  '122 - Demon Slayer Fight Scene.mp4',
  '123. - The Tunnel To Summer.mp4',
  '124 - The Aura Of Luffy.mp4',
  '125 - The Demon Slayer Best Scene.mp4',
  '126 - Jojo Pucci Edit.mp4',
  '127 - Onepiece Edit.mp4',
  '128 - Demon Slayed Eyes Edit.mp4',
  '129 - Satoro Gojo Edit.mp4',
  '13 - The Special Moment Of Onepiece.mp4',
  '130 - Lone Wolf Edit.mp4',
  '131 - Solo Leveling Edit.mp4',
  '132 - Top Anime Edit.mp4',
  '133 - Vinland Saga.mp4',
  '134 - Cyberpunk Edit.mp4',
  '135 - Blue Box Edit.mp4',
  '136 - Kurapika Edit.mp4',
  '137 - Solo Leveling Best Scene.mp4',
  '138 - Hunter Anime Edit.mp4',
  '139 - Gurren Lagann.mp4',
  '14 - The Danger In My Heart.mp4',
  '140 - Frieren Anime Edit.mp4',
  '141 - Attack On Titan Best Scene.mp4',
  '142 - Attack On Titan Fight Edit.mp4',
  '143 - Luffy In Skypia.mp4',
  '144 - Jujutsu Kaisen Best Scene.mp4',
  '145 - The Treasure Onepiece.mp4',
  '146 - Attack On Titan Edit.mp4',
  '147 - Yuki Flying Kiss.mp4',
  '148 - Death Note Edit.mp4',
  '149 - Black Clover Edit.mp4',
  '15 - Marvel Spiderman Edit.mp4',
  '150 - Top Anime Edits.mp4',
  '151 - The Strawhats Journey.mp4',
  '152 - Onepiece Badass Moments.mp4',
  '153 - The Quotes From Onepiece.mp4',
  '154 - Zoro Haiki Moment.mp4',
  '155 - Zoro Vs King.mp4',
  '156 - Luffy X Boa.mp4',
  '157 - Gta 6 Trailer.mp4',
  '158 - Luffy X Boa Funny Moment.mp4',
  '159 - Luffy X Marineford.mp4',
  '16 - The 3 Swordsman.mp4',
  '160 - Mr 3 Saved Luffy.mp4',
  '161 - Naruto X Hinata.mp4',
  '162 - Sanji X Puddin.mp4',
  '163 - Sanji X Zoro Funny Moment.mp4',
  '163 - The Ultimate Bounty.mp4',
  '165 - Onepiece Funny Momment.mp4',
  '166 - Sanji Emotional Moment.mp4',
  '167 - Zoro Haki.mp4',
  '168 - Strawhats Funny Moment.mp4',
  '169 - Sung Jin Woo Badass.mp4',
  '17 - The Death Of Jolenta.mp4',
  '170 - Vinsmoke Sanji.mp4',
  '171 - Solo Leveling Cute Moment.mp4',
  '172 - Onepiece X Lakers.mp4',
  '173 - Solo Leveling Badass Moment.mp4',
  '174 - Jujutsu Kaisen Best Scene.mp4',
  '175 - Attack On Titan Best Moment.mp4',
  '176 - Solo Leveling Emotional Scene.mp4',
  '177 - Solo Leveling Aura.mp4',
  '178 - Solo Leveling Beauty.mp4',
  '179 - Garp Scene.mp4',
  '18 - The Lord Of The Mysteries.mp4',
  '180 - Luffy Gear 2Nd.mp4',
  '181 - Sun God Nika.mp4',
  '182 - Luffy X Zoro.mp4',
  '183 - The Power Of Akatsuki.mp4',
  '184 - The Trust In Luffy.mp4',
  '185 - Akainu Vs Whitebeard.mp4',
  '186 - Luffy Vs Kaido.mp4',
  '187 - The Heart Break Moment.mp4',
  '188 - The Usopp Moment.mp4',
  '189 - Starwhats Badass Entry.mp4',
  '19 - Solo Leveling Best Moment.mp4',
  '190 - The Hardwork Of Zoro.mp4',
  '191 - Naruto X Sasuke.mp4',
  '192 - Top 10 Villains In Anime History.mp4',
  '193 - Luffy Gear 2Nd Scene.mp4',
  '194 - Trafaigar Law Revenge Scene.mp4',
  '195 - Franky Badass Moment.mp4',
  '196 - Vinland Saga Moment.mp4',
  '197 - Satao Gojo Edit.mp4',
  '198 - The Fans Of Zoro.mp4',
  '199 - Gear 5 Awaken Moment.mp4',
  '2 - Solo Leveling Best Scene.mp4',
  '20 - Solo Leveling Fight Scene.mp4',
  '200 - The D Family.mp4',
  '21 - Buggy X Shanks.mp4',
  '22 - Whitebeard Vs Akainu.mp4',
  '23 - The Aura Of Gol D Roger.mp4',
  '24 - Dr Stone Aura.mp4',
  '25 - Anime Charachter In Real Life.mp4',
  '26 - The Journey Of Strawhats.mp4',
  '27 - Cyberpunk Edgerunners Emotional Moment.mp4',
  '28 - Solo Leveling War.mp4',
  '29 - Onepiece Best Charachter.mp4',
  '3 - Mahito Aura.mp4',
  '30 - Luffy 2Nd Gear.mp4',
  '31 - Marvel Anime Edit.mp4',
  '32 - Fire Force Anime Edit.mp4',
  '33 - Jujutsu Kaisen Edit.mp4',
  '34 - Luffy Gear 5.mp4',
  '35 - Solo Leveling Edit.mp4',
  '36 - Solo Leveling War Scene.mp4',
  '37 - The Strawhat Pirates.mp4',
  '38 - Top Anime Esit.mp4',
  '39 - The Evil Laugh.mp4',
  '4 - Gojo The Best Charachter.mp4',
  '40 - Black Clover Edit.mp4',
  '41 - Luffy The Best Heart.mp4',
  '42 - The Aura Of Atomic.mp4',
  '43 - Onepiece The Journey.mp4',
  '44 - Luffy And Zoro.mp4',
  '45 - Zankyou Anime Edit.mp4',
  '46 - Beyond Journey End Edit.mp4',
  '47 - Demon Slayer Edit.mp4',
  '48 - The Black Lock Edit.mp4',
  '49 - Mikasa Edit.mp4',
  '5 - The Emperor Shanks.mp4',
  '50 - Demon Slayer Edit.mp4',
  '51 - Black Clover Edit.mp4',
  '52 - Luffy Vs Big Mom Army.mp4',
  '53 - Bocchi The Rock Edit.mp4',
  '54 - Spike Piegel Edit.mp4',
  '55 - Jujutsu Kaisen Sigma Scene.mp4',
  '56 - Gol D Roger Yreasure.mp4',
  '57 - Solo Leveling Fighting.mp4',
  '58 - Chainsawman Aura.mp4',
  '59 - Luffy X Zoro.mp4',
  '6 - The Ultimate Haki.mp4',
  '60 - Can I Clean Here.mp4',
  '61 - Trafaigar X Kid.mp4',
  '62 - Demon Slayer Best Scene.mp4',
  '63 - Doflamingo Aura.mp4',
  '64 - The Eyes Of Top Anime.mp4',
  '65 - The Top 5 Anime Edit.mp4',
  '66 - Solo Leveling Edit.mp4',
  '67 - The Aura Of Gojo.mp4',
  '68 - Jujutsu Kaisen Top Edit.mp4',
  '69 - The Land Of Wano Arc.mp4',
  '7 - The Forehead Haki Attack.mp4',
  '70 - Kid Vs Shanks.mp4',
  '71 - King Of The Pirate Luffy.mp4',
  '72 - Land Of Wano.mp4',
  '73 - The Aura Of Luffy.mp4',
  '74 - Sun God Nika.mp4',
  '75 - Luffy Intincts.mp4',
  '76 - Top 5 Anime Edits.mp4',
  '77 - Mix Anime Edit.mp4',
  '78 - Monkey D Luffy.mp4',
  '79 - Naruto X Onepiece.mp4',
  '8 - Eren When Lost His Patience.mp4',
  '80 - Nico Robin Edit.mp4',
  '81 - Onepiece Edit.mp4',
  '82 - One Piece Bounty.mp4',
  '83 - Onepiece Movie.mp4',
  '84 - Onepiece Over Everything.mp4',
  '85 - Best Anime Onepiece.mp4',
  '86 - Top 3 Anime Edit.mp4',
  '87 - Trendy Song Anime Edit.mp4',
  '88 - Bankai.mp4',
  '89 - Shanks The Emperor.mp4',
  '9 - The Sand Man Gaara.mp4',
  '90 - The Revenge For Usopp.mp4',
  '91 - Roronoa Zoro Wallpaper.mp4',
  '92 - Sanji X Zoro.mp4',
  '93 - The Haki Of Shanks.mp4',
  '94 - Mihawk X Shanks.mp4',
  '95 - The Strawhat Luffy.mp4',
  '96 - The Warlord Of The Sea.mp4',
  '97 - Onepiece Fight Scene.mp4',
  '98 - Marco The First Commander.mp4',
  '99 - Luffy Journey.mp4',
] as const;

export const SNAPFLIX_S3_VIDEO_URLS: string[] = FILE_NAMES.map(
  (name) => BASE + encodeURIComponent(name)
);
